import { render, staticRenderFns } from "./workBaoDetail.vue?vue&type=template&id=51de4a46&scoped=true"
import script from "./workBaoDetail.vue?vue&type=script&lang=js"
export * from "./workBaoDetail.vue?vue&type=script&lang=js"
import style0 from "./workBaoDetail.vue?vue&type=style&index=0&id=51de4a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51de4a46",
  null
  
)

export default component.exports